import { ClickAwayListener, styled, Tooltip } from '@rabex-kit/core';
import * as React from 'react';

export type CustomPopoverProps = {
  button: React.ReactElement;
  children:
    | React.ReactNode
    | ((isOpen: boolean, onClose: () => void) => React.ReactNode); // ✅ Add onClose
  openByClick?: boolean;
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start';
  offset?: [number, number];
};

const CustomTooltip = styled(Tooltip)(() => {
  return {
    '& > .MuiTooltip-tooltip': { backgroundColor: 'transparent', padding: 0 }
  };
});

export default function CustomPopover(props: CustomPopoverProps) {
  const {
    children,
    button,
    placement = 'bottom-start',
    openByClick = false,
    offset = [0, 0]
  } = props;
  const [open, setOpen] = React.useState(false);
  const containerRef = React.useRef<HTMLDivElement>(null);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleTooltipToggle = () => {
    setOpen((prevState) => !prevState);
  };

  // ✅ Pass both isOpen and onClose to children
  const content =
    typeof children === 'function'
      ? children(open, handleTooltipClose)
      : children;

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div ref={containerRef}>
        <CustomTooltip
          noWrap
          transparent
          title={content}
          placement={placement}
          PopperProps={{
            disablePortal: true,
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset
                }
              }
            ]
          }}
          onClose={handleTooltipClose}
          open={open}
          onOpen={handleTooltipOpen}
          onClick={openByClick ? handleTooltipToggle : handleTooltipOpen}
          disableFocusListener={openByClick}
          disableHoverListener={openByClick}
          disableTouchListener>
          {button}
        </CustomTooltip>
      </div>
    </ClickAwayListener>
  );
}
